export default "__VITE_ASSET__DTDDWyvQ__"